import React, { useEffect, useMemo } from "react";
import { REFRESH_TIMEOUT, TOOL_TEMPLATE } from "../constant/common";
import {
  useCompanySettings,
  useInstrumentsSetting,
  useTemplateSetting,
} from "../hooks/useCompanySettings";
import useInstruments from "../hooks/useInstruments";
import MultipleTickerRadio from "./MultipleTickerRadio";
import MultipleTickerSlider from "./MultipleTickerSlider";

export default function MultipleTicker() {
  const template = useTemplateSetting();
  const [{ instruments }, { getInstruments }] = useInstruments();
  const instrumentsSetting = useInstrumentsSetting();
  const { tickerRefreshSeconds } = useCompanySettings();
  const refreshTmeOut = tickerRefreshSeconds || REFRESH_TIMEOUT;

  const isSingleTicker = useMemo(() => instruments.length === 1, [instruments]);

  useEffect(() => {
    if (instrumentsSetting.length) {
      getInstruments();
    }
    const interval = setInterval(() => {
      if (instrumentsSetting.length) {
        getInstruments();
      }
    }, refreshTmeOut * 1000);
    return () => {
      clearInterval(interval);
    };
  }, [getInstruments, instrumentsSetting, refreshTmeOut]);

  if (isSingleTicker) return null

  return (
    <div className="MultipleTicker">
      {template === TOOL_TEMPLATE.quadrata && <MultipleTickerRadio />}
      {template === TOOL_TEMPLATE.victor && (
        <>
          <MultipleTickerSlider />
        </>
      )}
    </div>
  );
}
